import { render, staticRenderFns } from "./PublicacionLegacyView.vue?vue&type=template&id=77ae6b50"
import script from "./PublicacionLegacyView.vue?vue&type=script&lang=ts"
export * from "./PublicacionLegacyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports